export enum HtmlTags {
    All = '*',
    Div = 'div',
    Tr = 'tr',
    Td = 'td',
    Th = 'th',
    H6 = 'h6'
}
